<template>
  <div>
    <form class="flex w-full overflow-y-auto overflow-x-hidden" id="form-activity" autocomplete="off" >
      <div class="w-full pr-20" >
        <div class="flex flex-wrap -mx-3 mb-1">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700  font-bold mb-2" >
              Artworks and File
            </label>
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-1">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" >
              Artwork
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0">
            <p v-if="$v.input.artwork.$dirty && !$v.input.artwork.required" class="text-red-500 text-xs italic text-left">Please select song artwork.</p>
            <p v-if="isFileLarge" class="text-red-500 text-xs italic text-left">Please using image lower than 1MB</p>
            <input
              v-if="!input.artwork"
              type="file"
              class="block border border-grey-light w-full p-3 rounded"
              name="profile_picture"
              @change="onFileChange"
              accept="image/*"
            />
            <div class="tooltip" v-if="input.artwork" >
              <img
                style="width: 150px;"
                v-if="input.artwork"
                :src="input.artwork"
                @click="changeImage"
              />
              <span class="hint-tooltip" ><font-awesome-icon :icon="['fas', 'times-circle']" size="2x" @click="changeImage" /></span>
            </div>
            <div class="text-xs" >Minimum 900x900, Maximum 1MB</div>
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-1 mt-8">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 font-bold mb-2" >
              Metadata
            </label>
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-1">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-name-song">
              Name
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0">
            <p v-if="$v.input.musicName.$dirty && !$v.input.musicName.required" class="text-red-500 text-xs italic text-left">Please fill Song Name.</p>
            <p v-if="$v.input.musicName.$dirty && !$v.input.musicName.maxLength" class="text-red-500 text-xs italic text-left">Max length Song name is 100 character.</p>
            <input class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-1 leading-tight focus:outline-none focus:bg-white" id="grid-name-song" type="text" v-model="input.musicName" placeholder="Song Name" autocomplete="off" >
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-1">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-name-music">
              Description
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0 relative">
            <p v-if="$v.input.musicDescription.$dirty && !$v.input.musicDescription.required" class="text-red-500 text-xs italic text-left">Please fill the Description.</p>
            <p v-if="$v.input.musicDescription.$dirty && !$v.input.musicDescription.maxLength" class="text-red-500 text-xs italic text-left">Max length description song is 1000 character</p>
            <textarea rows="7" class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-1 leading-tight focus:outline-none focus:bg-white" id="grid-name-music" type="text" v-model="input.musicDescription" placeholder="Description Song" autocomplete="off" ></textarea>
            <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 40px;" >{{input.musicDescription.length}}/{{maxLengthDesc}}</div>
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-1">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-year-music">
              Year
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0">
            <p v-if="$v.input.year.$dirty && !$v.input.year.required" class="text-red-500 text-xs italic text-left">Please fill Year Song.</p>
            <p v-if="$v.input.year.$dirty && !$v.input.year.numeric" class="text-red-500 text-xs italic text-left">Please fill Year Song with number.</p>
            <p v-if="$v.input.year.$dirty && !$v.input.year.maxLength" class="text-red-500 text-xs italic text-left">Max length Year Song is 4 character.</p>
            <input class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-1 leading-tight focus:outline-none focus:bg-white" id="grid-year-music" type="text" v-model="input.year" placeholder="ex. 2020" autocomplete="off" >
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-1">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-genre-song" >
              Category
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0">
            <p v-if="$v.input.genre.$dirty && !$v.input.genre.required" class="text-red-500 text-xs italic text-left">Please select song category.</p>
            <select
              id="grid-genre-song"
              type="text"
              class="block border border-grey-light w-full p-3 rounded mb-4"
              name="genre"
              v-model="input.genre"
            >
              <option :value="null" disabled >Select Song Category</option>
              <option
                v-for="(item, key) in listGenreSong"
                :key="key"
                :value="item.id"
                :v-text="item.name"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-4">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-genre-song" >
              Language
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0">
            <p v-if="$v.input.language.$dirty && !$v.input.language.required && isArtist" class="text-red-500 text-xs italic text-left">Please choose language.</p>
            <el-select v-model="input.language" filterable placeholder="Select Language" class="w-full">
              <el-option
                v-for="item in dataLanguages"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-1">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
              Copyright
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0">
            <label
              for="toogleCopyRightEdit"
              class="flex items-center cursor-pointer"
            >
              <!-- toggle -->
              <div class="relative">
                <!-- input -->
                <input id="toogleCopyRightEdit" type="checkbox" v-model="input.copyRight" class="hidden"  />
                <!-- line -->
                <div
                  class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                ></div>
                <!-- dot -->
                <div
                  class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                ></div>
              </div>
              <!-- label -->
              <div
                class="ml-3 text-gray-700 font-medium"
              >
                {{ input.copyRight ? 'Yes' : 'No' }}
              </div>
            </label>
          </div>
        </div>
        <div v-if="input.copyRight" class="flex flex-wrap -mx-3 mb-1">

        </div>
        <div v-if="input.copyRight" class="flex flex-wrap -mx-3 mb-1">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" >
              Upload Copyright
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0">
            <p v-if="$v.input.copyRightFile.$dirty && !$v.input.copyRightFile.required" class="text-red-500 text-xs italic text-left">Please select copyright file.</p>
            <input
              v-if="!input.copyRightFile"
              type="file"
              class="block border border-grey-light w-full p-3 rounded"
              name="copyright_file"
              @change="onFileChangeCopyRight"
              accept="image/*,application/pdf,application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint"
            />
            <div v-if="input.copyRightFile" class="flex" >
              <a :href="input.copyRightFile" target="_blank" v-if="input.copyRightFile == song.copyright"
                 class="underline font-bold mr-2"
              >Copyright Link</a>
              <span class="mr-2 text-gray-700 font-medium" v-else>{{copyRightFileName}}</span>
              <a @click="changeCopyRight" ><font-awesome-icon :icon="['fas', 'times-circle']"   /></a>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-1 mt-8">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 font-bold mb-2" >
              Monetization
            </label>
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-1">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
              Subscription
              <br />
              <small class="text-gray-700 font-medium" >Turn on to earn revenue per song stream.</small><br/>
              <small class="text-gray-700 font-medium" >Turn off if users can listen for free</small>
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0">
            <label
              for="toogleSubsEdit"
              class="flex items-center cursor-pointer"
            >
              <!-- toggle -->
              <div class="relative">
                <!-- input -->
                <input id="toogleSubsEdit" type="checkbox" v-model="input.isSubscription" class="hidden"  />
                <!-- line -->
                <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                <!-- dot -->
                <div class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
              </div>
              <!-- label -->
              <div class="ml-3 text-gray-700 font-medium" >
                {{ input.isSubscription ? 'On' : 'Off' }}
              </div>
            </label>
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-1" >
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
              Sell song
              <br />
              <small class="text-gray-700 font-medium" >Allow user to buy this song? </small>
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0" >
            <label
              for="tooglePaidEdit"
              class="flex items-center cursor-pointer"
            >
              <!-- toggle -->
              <div class="relative">
                <!-- input -->
                <input id="tooglePaidEdit" type="checkbox" v-model="input.isPaid" class="hidden"  />
                <!-- line -->
                <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                <!-- dot -->
                <div class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
              </div>
              <!-- label -->
              <div class="ml-3 text-gray-700 font-medium" >
                {{ input.isPaid ? 'Yes' : 'No' }}
              </div>
            </label>
          </div>
        </div>
        <div v-if="input.isPaid " class="flex flex-wrap -mx-3 mb-1">
          <div class="w-1/4 md:w-1/4 px-3 mb-1 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-price-music">
              Song Price (USD)
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-1 md:mb-0">
            <p v-if="$v.input.price.$dirty && !$v.input.price.required" class="text-red-500 text-xs italic text-left">Price is required.</p>
            <p v-if="$v.input.price.$dirty && !$v.input.price.decimal" class="text-red-500 text-xs italic text-left">Price must be a number.</p>
            <label
            >
              $ <input class="appearance-none bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-price-music" type="text" v-model="input.price" placeholder="ex. 5" autocomplete="off" >
              &nbsp;&nbsp;&nbsp; = {{ creditPrice }} Credits</label>
          </div>
        </div>
        <div v-if="input.isPaid && input.price != 0 " class="flex flex-wrap -mx-3 mb-6">
          <div class="w-1/4 md:w-1/4 px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-price-music">
              MusicVerse Cut
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-6 md:mb-0">
            <!-- <input class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-price-music" type="text" v-model="" placeholder="5" autocomplete="off" disabled > -->
            $ {{ priceMusicVerse }}
          </div>
        </div>
        <div v-if="input.isPaid && input.price != 0 " class="flex flex-wrap -mx-3 mb-6">
          <div class="w-1/4 md:w-1/4 px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-price-music">
              Artist Cut
            </label>
          </div>
          <div class="w-3/4 md:w-3/4 px-5 mb-6 md:mb-0">
            <!-- <input class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-price-music" type="text" v-model="" placeholder="5" autocomplete="off" disabled > -->
            $ {{ priceArtistMusicVerse }}
          </div>
        </div>
        <div v-if="progressbar!==0" class="flex flex-wrap -mx-3 mb-3">
          <div class="shadow w-full bg-grey mt-2">
            <div class="bg-teal-500 text-xs leading-none py-1 text-center text-white" :style="`width: ${progressbar}%;`">{{progressbar}}%</div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, numeric, decimal, maxLength } from 'vuelidate/lib/validators';
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import helpersMixin from '../../mixins/helpers.mixins';

export default {
  name: 'EditSong',
  mixins: [validationMixin, helpersMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    musicverseCut: {
      type: Number,
      default: () => 70,
    },
    artistCut: {
      type: Number,
      default: () => 30,
    },
    song: {
      type: Object,
      default: () => ({
        title: '',
        id: '',
        content_id: '',
        is_album_only: '',
        genre: '',
        description: '',
        cover: null,
        copyright: null,
        is_paid: 0,
        is_subscription: 0,
        language: '',
        price: 0,
        year: '',
      }),
    },
  },
  data() {
    return {
      maxLengthDesc: 1000,
      dataLanguages: [],
      input: {
        contentId: '',
        musicName: '',
        musicDescription: '',
        genre: '',
        year: '',
        artwork: '',
        price: '',
        isAlbumOnly: false,
        isPaid: false,
        isSubscription: false,
        copyRight: false,
        copyRightFile: null,
        language: '',
      },
      progressbar: 0,
      isFileLarge: false,
      isFileMusicNotMP3: false,
      isError: false,
      copyRightFileName: '',
      listLanguage: [{
        id: 'Bahasa Indonesia',
        name: 'Bahasa Indonesia',
      }, {
        id: 'Malay',
        name: 'Malay',
      }, {
        id: 'Tagalog',
        name: 'Tagalog',
      }, {
        id: 'English',
        name: 'English',
      }],
    };
  },
  validations() {
    const rule = {
      input: {
        musicName: {
          required,
          maxLength: maxLength(100),
        },
        musicDescription: {
          required,
          maxLength: maxLength(1000),
        },
        genre: {
          required,
        },
        year: {
          required,
          numeric,
          maxLength: maxLength(4),
        },
        artwork: {
          required,
        },
        language: {},
      },
    };

    if (this.isArtist) {
      rule.input.language = {
        required,
      };
    }

    if (this.input.isPaid) {
      rule.input.price = {
        required,
        decimal,
      };
    }
    if (this.input.copyRight) {
      rule.input.copyRightFile = {
        required,
      };
    }
    return rule;
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isArtist', 'isFinance', 'isOps', 'isReviewer', 'isRecruitment', 'getUser']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('SongModule', [
      'getPercentageUpload',
      'listGenreSong',
    ]),
    priceMusicVerse() {
      return !isNaN(this.input.price) ? parseFloat(this.input.price * (this.musicverseCut / 100)).toFixed(2) : 0;
    },
    creditPrice() {
      return !isNaN(this.input.price) ? parseFloat(this.toCredit(this.input.price)).toFixed(2) : 0;
    },
    priceArtistMusicVerse() {
      return !isNaN(this.input.price) ? parseFloat(this.input.price * (this.artistCut / 100)).toFixed(2) : 0;
    },
  },
  watch: {
    getPercentageUpload: {
      immediate: true,
      handler(val) {
        if (val !== 0) {
          this.progressbar = val;
        }
      },
    },
    toggleReset: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetState();
        }
      },
    },
  },
  async mounted() {
    // await this.requestListGenreSong();
    this.dataLanguages = this.getLanguages();
  },
  methods: {
    ...mapActions('SongModule', [
      'requestUpdateSubmissionSong',
      'requestEditSong',
      'requestListGenreSong',
      'requestDeleteSubmission',
    ]),
    resetState() {
      this.$v.$reset();
      this.progressbar = 0;
      this.isError = false;
      this.isFileLarge = false;
      this.copyRightFileName = '';
      const findLang = this.dataLanguages.find(lang => lang.value == this.song.language);
      this.languages = findLang != undefined ? findLang.label : '-';
      this.input = Object.assign({}, {
        contentId: this.isArtist ? this.song.content_id : this.song.id,
        musicName: this.song.title,
        musicDescription: this.song.description,
        genre: this.listGenreSong.find(element => element.name.toLowerCase().indexOf(this.song.genre.replaceAll(/_/ig, ' ').toLowerCase()) !== -1).id || '',
        year: this.song.year,
        artwork: this.song.cover,
        isPaid: this.song.price > 0 && this.song.is_paid == 1,
        isSubscription: this.song.is_subscription == 1,
        price: this.song.price > 0 ? this.toDollar(this.song.price) : 0,
        copyRight: !!this.song.copyright,
        copyRightFile: this.song.copyright,
        isAlbumOnly: false,
        language: findLang != undefined ? this.song.language : null,
      });
      this.copyRightFileName = 'Copyright Link';
    },
    onFileChange(e) {
      this.isFileLarge = false;
      const file = e.target.files[0];
      if (file.size > 1024 * 1024) {
        this.$v.dirty = true;
        this.isFileLarge = true;
      }
      this.input.artwork = URL.createObjectURL(file);
    },
    onFileChangeCopyRight(e) {
      const file = e.target.files[0];
      this.input.copyRightFile = this.getExt(file.name) == 'pdf' ? file : URL.createObjectURL(file);
      this.copyRightFileName = file.name;
    },
    getExt(name) {
      const fileInfo = name.split('.');
      return fileInfo[fileInfo.length - 1];
    },
    changeImage() {
      this.input.artwork = null;
    },
    changeCopyRight() {
      this.input.copyRightFile = null;
    },

    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
    async submit() {
      try {
        this.$v.$touch();
        if (!this.$v.$invalid && !this.isFileLarge) {
          const dataSong = new FormData();
          dataSong.append('title', this.input.musicName);
          dataSong.append('description', this.input.musicDescription);
          dataSong.append('year', this.input.year);
          dataSong.append('genre_id', this.input.genre);
          if (this.input.artwork != this.song.cover) {
            const resultImage = await axios({
              method: 'get',
              url: this.input.artwork,
              responseType: 'blob',
            }).then(this.processFileBlob);
            dataSong.append('cover', resultImage);
          } else {
            dataSong.append('cover', '');
          }
          dataSong.append('is_paid', this.input.isPaid ? 1 : 0);
          dataSong.append('price', this.input.isPaid ? this.toCredit(this.input.price) : 0);
          dataSong.append('is_subscription', this.input.isSubscription ? 1 : 0);
          dataSong.append('is_album_only', 0);
          dataSong.append('content_id', this.input.contentId);
          dataSong.append('language', this.input.language);
          if (this.input.copyRight && this.input.copyRightFile != this.song.copyright) {
            const ext = this.getExt(this.copyRightFileName);
            if (ext != 'pdf') {
              const resultCopyRight = await axios({
                method: 'get',
                url: this.input.copyRightFile,
                responseType: 'blob',
              }).then(this.processFileBlob);
              dataSong.append('copyright', resultCopyRight);
              dataSong.append('copyright_type', 'image');
            } else {
              dataSong.append('copyright', this.input.copyRightFile);
              dataSong.append('copyright_type', 'pdf');
            }
          } else if (!this.input.copyRight) {
            dataSong.append('copyright', '');
          }
          if (this.isArtist) {
            await this.requestUpdateSubmissionSong(dataSong);
          } else {
            await this.requestEditSong(dataSong);
          }
          this.resetState();
          this.$emit('on-edit-song', true);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        this.isError = true;
      }
    },
  },
};
</script>

<style scoped>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
</style>



// WEBPACK FOOTER //
// src/views/contents/EditSong.vue